var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOrderProcessing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9473 7.47367H19.5488V2.84961H24.4715C24.6564 2.84961 24.837 2.90499 24.99 3.00861C25.1431 3.11224 25.2616 3.25934 25.3302 3.43095L26.9473 7.47367Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05267 10.2485H19.5489",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9361 18.5716C22.4684 18.5716 23.7106 17.3294 23.7106 15.7971C23.7106 14.2649 22.4684 13.0227 20.9361 13.0227C19.4038 13.0227 18.1617 14.2649 18.1617 15.7971C18.1617 17.3294 19.4038 18.5716 20.9361 18.5716Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06393 18.5716C8.59621 18.5716 9.83837 17.3294 9.83837 15.7971C9.83837 14.2649 8.59621 13.0227 7.06393 13.0227C5.53165 13.0227 4.28949 14.2649 4.28949 15.7971C4.28949 17.3294 5.53165 18.5716 7.06393 18.5716Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1616 15.7971H9.83832",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28952 15.797H1.97749C1.73221 15.797 1.49698 15.6996 1.32354 15.5261C1.15011 15.3527 1.05267 15.1175 1.05267 14.8722V1.92481C1.05267 1.67954 1.15011 1.44431 1.32354 1.27087C1.49698 1.09744 1.73221 1 1.97749 1H19.5489V13.3942M19.5489 13.3942V7.47369H26.9474V14.8722C26.9474 15.1175 26.85 15.3527 26.6766 15.5261C26.5031 15.6996 26.2679 15.797 26.0226 15.797H23.7106",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderProcessing);
export default __webpack_public_path__ + "static/media/icon-order-processing.8058b9da6f342bf320da6c2ee2e07555.svg";
export { ForwardRef as ReactComponent };